import { useCallback, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

export const useEmployerPricingPreview = () => {
    const [data, setData] = useState(null), [error, setError] = useState("");
    const [loading, setLoading] = useState(true), [attempt, setAttempt] = useState(0);
    useEffect(() => {
        let cancelled = false;
        setLoading(true); setError(""); setData(null);
        api.get("/admin/pricing-preview/employer")
            .then(({ data }) => { if (!cancelled) setData(data); })
            .catch(err => { if (!cancelled) setError(formatApiError(err)); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [attempt]);
    const retry = useCallback(() => setAttempt(value => value + 1), []);
    return { data, error, loading, retry };
};